// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14qVd","top":"styles_top__Sm43B","left":"styles_left__3tL3y","description":"styles_description__3ufw-"};